<!-- Role Upgradation Request Table Content -->
<app-table
          [columns]="roleUpgradeColumns"
          [data]="roleUpgradeData"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="roleUpgradePagination"
          [emptyMessage]="roleUpgradeEmptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          (pageChange)="onRoleUpgradePageChange($event)"
          (pageSizeChange)="onRoleUpgradePageSizeChange($event)"
        >
          <!-- Custom Status Column with Chip Design -->
          <ng-template #roleUpgradeStatusCell let-row>
            <span class="status-chip" 
                  [class.status-chip--pending]="isStatusPending(row.status)" 
                  [class.status-chip--approved]="row.status?.toLowerCase() === 'granted' || row.status?.toLowerCase() === 'approved'"
                  [class.status-chip--rejected]="row.status?.toLowerCase() === 'rejected'">
              {{ row.status || 'N/A' }}
            </span>
          </ng-template>

          <!-- Custom Action Column for Role Upgradation -->
          <ng-template #roleUpgradeActionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
                type="button"
              >
                <span>Action</span>
              </button>
              
              <!-- Dropdown Menu (always open on click; list items disabled when already processed) -->
              <div 
                class="action-dropdown-menu" 
                *ngIf="isDropdownOpen(row)" 
                [attr.data-dropdown-id]="getRowId(row)"
                (click)="$event.stopPropagation()"
              >
                <ul class="dropdown-list">
                  <li class="dropdown-item">
                    <button 
                      class="dropdown-link" 
                      [disabled]="isStatusProcessed(row.status)"
                      (click)="!isStatusProcessed(row.status) && handleRoleUpgradeAction('approve', row)"
                    >
                      Approve
                    </button>
                  </li>
                  <li class="dropdown-item">
                    <button 
                      class="dropdown-link dropdown-link--danger" 
                      [disabled]="isStatusProcessed(row.status)"
                      (click)="!isStatusProcessed(row.status) && handleRoleUpgradeAction('reject', row)"
                    >
                      Reject
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-template>
</app-table>
